<template>
    <tr id="row">
      <td>
        <div class="row1 d-flex flex-column align-items-start justify-content-center">
          <div class="lg1">
            <span class="title">{{title.lg1}}</span> <span class="subtitle">{{subtitle.lg1}}</span>
          </div>
        </div>
        <div class="row2 lg2">
          <span class="title">{{title.lg2}}</span > <span class="subtitle">{{subtitle.lg2}}</span>
        </div>
      </td>
      <td>
        <div class="price d-flex flex-column align-items-end justify-content-center">
          <div>{{price}}</div>
          <div class="lg2">{{ freeOfCharge }}</div>
        </div>
      </td>
    </tr>
</template>

<script>
export default {
  name: 'NovotelRatesHorizontalV2ServicesRow',
  props: {
    ratesLg: Object,
  },
  computed: {
    title () {
      return {lg1: this.ratesLg.lg1.label_value, lg2: this.ratesLg.lg2.label_value}
    },
    subtitle () {
      return {lg1: this.ratesLg.lg1.sub_label, lg2: this.ratesLg.lg2.sub_label}
    },
    price () {
      return this.ratesLg.lg1.msr_value
    },
    price2 () {
      return this.ratesLg.lg2.msr_value
    },
    freeOfCharge () {
      if (this.price === this.price2) {
        return ''
      } else {
        return this.price2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_novotel.scss";


tr {
  border-bottom: 1px solid $grey;

    &:last-of-type {
    border-bottom: none;
  }

  td:nth-of-type(1) {
    @include widthPercent(640);
  }

  td:nth-of-type(2) {
    @include widthPercent(170);
  }

  .row1 {
    height: 100%;
    @include heightPercent(50);
    @include widthPercent(638);

    .lg1 {
      max-height: 2rem;
      overflow: hidden;

      .title {
        font-family: "Montserrat-Regular";
        @include fontSize(36);
        line-height: 1.2em;;
      }

      .subtitle {
        font-family: "Montserrat-Regular";
        @include fontSize(30);
        line-height: 1.2em;;
      }
    }
  }

  .row2 {
    overflow: hidden;
    @include heightPercent(50);

    .title { 
      font-family: "Montserrat-Regular";
      @include fontSize(36);
      line-height: 1.2em;
    }

    .subtitle {
      font-family: "Montserrat-Regular";
      @include fontSize(36);
      line-height: 1.2em;
    }
  }

  .price {
    font-family: "Montserrat-Regular";
    height: 100%;
    @include fontSize(36);
    color: $grey;
    white-space: normal;
    border-left: 1px solid $grey;
    //@include widthPercent(170);
    width: 100%;
    text-align: right;

    .lg2 {
      @include fontSize(24);
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/novotel/rates/horizontal/v2/rates/rowServices.vue